module.exports = __webpack_public_path__ + "static/media/blaine-max.546793b3.wav";